import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router,RouterModule  } from '@angular/router';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SelfVerificationService } from '../service/self-verification.service';
import { CountryService } from '../service/country.service';

export interface person {
  companyEmail:string,  ​
  companyName:string,  ​
  companyNationalId:string,  ​
  email:string,  ​
  employeeType:string,  ​
  firstName:string,  ​
  lastName:string,  ​
  mdmid:string,  ​
  nationalId:string,  ​
  nationality:string,  ​
  oneUp: any,  ​
  organizationalLevel:string,  ​
  passportNumber: any,  ​
  personnelArea:string,  ​
  personnelSubareaName:string,  ​
  phoneNumber:string,  ​
  title: string
}


@Component({
  selector: 'app-external-verification',
  templateUrl: './external-verification.component.html',
  styleUrls: ['./external-verification.component.css']
})
export class ExternalVerificationComponent implements OnInit {
  ApproverId= new UntypedFormControl([Validators.required])
  options:any[];
  filteredOptions: Observable<any>;
  verificationExternal:any[];
  countries: Array<any>;

   //---people for mat autocomplete
   peoples=  [];
   searchPeople :string;
   personFound = false;
   personNotFound = false;
   person: any=[];
   mdmId: string;
   emailDocument: string;
  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private dataApi: SelfVerificationService,
    private countryApi: CountryService,
    public dialog: MatDialog,
  ) { }

  searchSubject = new Subject<string>();

  ngOnInit() {
    this.getCountires();
    this.initSearchPipeline();
  }

  ngOnDestroy() {
    this.searchSubject.complete();
  }

  getCountires() {
    this.countryApi
      .getAll()
      .subscribe((response: Array<any>) => {
        this.countries = response;
      });
  }

  initSearchPipeline(): void {
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(nameSearch => {
        if(nameSearch.trim() === '') {
          this.peoples = [];
          this.spinner.hide();
          return [];
        }
        this.spinner.show();
        this.person = [];
        this.personFound = true;
        this.personNotFound = false;
        return this.dataApi.getSearchExternal(nameSearch).pipe(
          catchError(err => {
            this.peoples = [];
            this.spinner.hide();
            return of([]);
          })
        );
      })
    ).subscribe({
      next: (data: any) => {
        if(data == null || data == undefined || data.length == 0) {
          this.peoples = [];
          this.personNotFound = true;
          this.spinner.hide();
        } else {
          let peoples = [];
          data.forEach(element => {
            if(element.email=='' || element.email==null)
              element.email = element.companyEmail;
            peoples.push(element);
          });
          this.peoples = peoples;
        }
        this.spinner.hide();
      },
      error: (err: any) => {
        this.peoples = [];
        this.spinner.hide();
      }
    });

  }

  getlang(){
    return sessionStorage.getItem('lang');
  }

  searchPerson(event: Event) {
    const nameSearch = (event.target as HTMLInputElement).value;
    this.searchSubject.next(nameSearch);
  }

  addpeopleMdmidFilterValue(option){
    this.person= option;
    this.emailDocument = this.person.email + '-*' + (this.person.nationalId == null ? this.person.passportNumber : this.person.nationalId) + '-*' + (this.person.nationalId == null ? 'Passport' : 'RUT');
  }

  redirect(value){
    this.mdmId = value.mdmid;
    this.router.navigate(['external-accesses']);
  }

 searchCountry(nationality: string) {
    const key = this.getlang() === "es" ? "nameEs" : "name";
    const needle = nationality.trim().toLowerCase();
    const found = this.countries.find(c => (c.code ?? "").toLowerCase() === needle);
    return found ? found[key] : nationality;

   }

}
